const DATA_CACHE="SURVIVOR_SEARCH_CACHE"
const TWO_WEEKS = 1000 * 60 * 60 * 24 * 14

const currentTime=()=>{
    return Date.now()
}

const getSurvivorSearchCache=()=>{

    let cache={
        data:{},
        nextCleanup:new Date().getTime()+TWO_WEEKS
    }  

    try {
        const data=localStorage.getItem(DATA_CACHE)

        if(data){
            cache=JSON.parse(data)
        }
    }
    catch(e){
        console.error(e.message)
    }

    return cache
}

const setSurvivorSearchCache=(userId,value)=>{

    const cache=getSurvivorSearchCache()
    const data=cache.data


    const item={
        id:userId,
        expiry:new Date().getTime()+TWO_WEEKS,
        val:value
    }

    data[userId]=item

    try{
        localStorage.setItem(DATA_CACHE,JSON.stringify(cache))
    }
    catch(e){
        cleanUpStorage(data)
    }

}

const cleanUpStorage=(data)=>{

    let isDeleted
    let oldest
    let oldestKey


    //if 14 days have been passed, it removes the cache
    for (const key in data) {
        const expiry = data[key].expiry
        if (expiry && expiry <=currentTime()) {
          delete data[key]
          isDeleted = true
        }
    
        //finding the oldest cache in case none of them are expired
        if (!oldest || oldest > expiry) {
          oldest = expiry
          oldestKey=key
        }
    }

    //remove the oldest cache if there is no more space in local storage (5 MB)
    if(!isDeleted && oldestKey){
        delete data[oldestKey]
    }

    localStorage.setItem(
        DATA_CACHE,
        JSON.stringify({
          data: data,
          nextCleanup:currentTime() + TWO_WEEKS,
        })
    )

}

export {setSurvivorSearchCache,getSurvivorSearchCache}
